<template>
  <div class="container">
    <UnsupportedBrowserMsg />
    <div class="header__cont">
      <a :href="url.home" class="header__logo d-flex">
        <vue-icon type="logo"></vue-icon>
      </a>
      <div class="menu__wrapper">
        <ul class="menu">
          <li class="menu__item">
            <a class="menu__link" :href="url.home">{{ $t('Maps') }}</a>
          </li>
          <li class="menu__item">
            <a class="menu__link" :href="url.functions">{{ $t('Features') }}</a>
          </li>
<!--						TODO hidden until compelted-->
<!--						-->
<!--						<li class="menu__item">-->
<!--							<a class="menu__link" :href="url.blog">{{ $t('Video tutorials') }}</a>-->
<!--						</li>-->
          <li class="menu__item">
            <a class="menu__link" :href="url.pricing">{{ $t('Pricing') }}</a>
          </li>
<!--						<li class="menu__item" v-if="isSuperuserComputed">-->
<!--							<a class="menu__link" :href="url.translate_list">{{ $t('Translate') }}</a>-->
<!--						</li>-->
          <li class="menu__item">
            <a class="menu__link" @click="mymapsClickHandler" :href="url.profile">{{ $t('My maps') }}</a>
          </li>
          <li class="menu__item">
            <a class="menu__link" @click="mymapsClickHandler" :href="url.topics">{{ $t('Topics') }}</a>
          </li>
          <li class="menu__item">
            <a class="menu__link" :href="url.exercises">{{ $t('Exercises') }}</a>
          </li>
          <li class="menu__item">
            <a class="menu__link" :href="mapularyLocaleLink" target="_blank">{{ $t('About') }}</a>
          </li>
        </ul>

<!--					<div class="mobileCreateMap">-->
<!--						<vue-button-->
<!--											@click="$root.editorMapCreate($event)"-->
<!--											class="btn btn&#45;&#45;circle btn&#45;&#45;green mr-3"-->
<!--											:title="$t(`Create map`)"-->
<!--										>-->
<!--											<vue-icon type="plus"></vue-icon>-->
<!--										</vue-button>-->
<!--					</div>-->

        <div class="mobileCreateMap"><vue-button
          @click="$root.editorMapCreate($event)"
          class="btn btn--circle btn--green mr-3"
          :title="$t(`Create map`)"
        >
          <vue-icon type="plus"></vue-icon>
        </vue-button></div>

          <input @click="profileMenuClickHandler" type="checkbox" v-model="isProfileMenuOpened" class="mobileUser_toggle">
          <div class="hamburgerUser d-flex-center">
            <div class="btn btn--circle btnMobileUser">
            <vue-icon type="user"></vue-icon>
              </div>
          </div>

        <div class="mobileUser">
          <div class="mobileUser__menu d-flex-center">
            <div class="d-flex-center">
              <div class="d-flex-center d-flex-column userMenuMobile">
                <slot name="user-profile-info-mobile"></slot>
              </div>
            </div>
          </div>
        </div>

        <div class="mobileLang">
                    <slot  name="language-selector"></slot>
                  </div>

        <div class="mobileMenu">
          <input @click="menuClickHandler" v-model="isMenuOpened" class="mobileMenu__toggle" type="checkbox"/>
          <div class="hamburger d-flex-center">
            <div></div>
          </div>
          <div class="btn btn--circle btn--brown btnMobileMenuBg"></div>
          <div class="mobileMenu__menu d-flex-center">
            <div class="d-flex-center">
              <div class="d-flex-center d-flex-column">
                <div class="mobileMenu__btns d-flex">

<!--										<a-->
<!--											class="btn btn&#45;&#45;circle btn&#45;&#45;brown"-->
<!--											@click="profileClickHandler"-->
<!--											:title="isAuthenticated ? $t('User Account') : $t('Login')"-->
<!--											:href="url.profile"-->
<!--										>-->
<!--											<vue-icon type="user"></vue-icon>-->
<!--											<span v-show="hasUnreadNotifications" class="btn__num">{{ countUnreadNotifications }}</span>-->
<!--										</a>-->
<!--										<slot name="user-profile-info"></slot>-->

                </div>
                <ul class="mobileMenu__list">
                  <li>
                    <a class="link underline" :href="url.home">{{ $t('Maps') }}</a>
                  </li>
                  <li>
                    <a class="link underline" @click.prevent="$root.editorMapCreate()" >{{ $t('Create map') }}</a>
                  </li>
                  <li>
                    <a class="link underline" :href="url.functions">{{ $t('Features') }}</a>
                  </li>
                  <!--						TODO hidden until compelted-->
<!--						-->
<!--										<li>-->
<!--											<a class="link underline" :href="url.blog">{{ $t('Video tutorials') }}</a>-->
<!--										</li>-->
                  <li>
                    <a class="link underline" :href="url.pricing">{{ $t('Pricing') }}</a>
                  </li>
<!--										<li v-if="isSuperuserComputed">-->
<!--											<a class="link underline" :href="url.translate_list">{{ $t('Translate') }}</a>-->
<!--										</li>-->
                  <li>
                    <a class="link underline" @click="mymapsClickHandler" :href="url.profile">{{ $t('My maps') }}</a>
                  </li>
                  <li>
                    <a class="link underline" :href="url.topics">{{ $t('Topics') }}</a>
                  </li>
                  <li>
                    <a class="link underline" :href="url.exercises">{{ $t('Exercises') }}</a>
                  </li>
                  <li>
                    <a class="link underline" :href="mapularyLocaleLink" target="_blank">{{ $t('About') }}</a>
                  </li>
<!--										<li>-->
<!--											<a class="link underline" :href="url.logout">{{ $t('Logout') }}</a>-->
<!--										</li>-->
                </ul>
                <div class="mobileMenu__createbtn">
                <vue-button
                    @click="$root.editorMapCreate($event)"
                    class="btn btn--green mr-3"
                    :title="$t(`Create map`)"
                  >
                    <vue-icon type="plus"></vue-icon>
                    <span>{{ $t('Create map') }}</span>
                  </vue-button>
                  </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="header__right">
        <vue-button
          @click="$root.editorMapCreate($event)"
          class="btn btn--green mr-3"
          :title="$t(`Create map`)"
        >
          <vue-icon type="plus"></vue-icon>
          <span>{{ $t('Create map') }}</span>
        </vue-button>
        <div style="position: relative; width: max-content; width: -moz-max-content;">
          <a
            class="btn btn--circle btn--brown"
            @click="profileClickHandler"
            @mouseenter="isAuthenticated && $root.notificationBoxShow($event, { id: 'user-profile-info' })"
            @mouseleave="isAuthenticated && $root.notificationBoxHide($event, 'user-profile-info')"
            :title="isAuthenticated ? $t('User Account') : $t('Login')"
            :href="url.profile"
          >
            <vue-icon type="user"></vue-icon>
            <span v-show="hasUnreadNotifications" class="btn__num">{{ countUnreadNotifications }}</span>
          </a>
          <slot name="user-profile-info"></slot>
        </div>
        <!-- hidden as per issue #43079
{#				<a href="{% url 'pricing' %}"#}
           class="btn btn--circle btn--brown mr-3"
           title="{% trans 'Buy' %}">
          <vue-icon type="basket"></vue-icon>
        </a>
        <a href="#" class="btn btn--circle btn--brown">
          <vue-icon type="search"></vue-icon>
        </a>
        -->
        <!-- Lang selector -->
        <slot name="language-selector"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import reverse               from 'django-reverse';
import UnsupportedBrowserMsg from '__components__/MainHeader/UnsupportedBrowserMsg';
import {MODAL_TYPES}         from '__application-config__';


export default {
	name: `vue-main-header`,

	props: {
		countUnreadNotifications: {type: Number, required: false, default: 0},
		isSuperuser: {type: Boolean, required: true, default: false}
	},

	data() {
		return {
			isHeaderFixed: false,
			isMenuOpened:false,
			isProfileMenuOpened:false,
		};
	},

	computed: {
		languageId() {
			return this.$store.state.language;
		},
    mapularyLocaleLink() {
		  if (this.languageId !== 'cs') {
		    return `https://www.mapulary.com/${this.languageId}`
      } return 'https://www.mapulary.com/'
    },

		url() {
			return {
				home: reverse(`homepage`, this.languageId),
				functions: reverse(`functions`, this.languageId),
				blog: reverse(`blog:blog_list`, this.languageId),
				pricing: reverse(`pricing`, this.languageId),
				profile: reverse(`myProfile`, this.languageId),
				translate_list: reverse(`translate_list`, this.languageId),
				topics: reverse(`topics`, this.languageId),
				logout: reverse(`logout`, this.languageId),
				exercises: reverse(`exercises`, this.languageId),
			}
		},

		isAuthenticated() {
			return this.$root.user.authenticated;
		},

		hasUnreadNotifications() {
			return (
				this.isAuthenticated && !!parseInt(this.countUnreadNotifications, 10)
			);
		},

		isSuperuserComputed() {
			return this.isSuperuser === 'True';
		}
	},

	methods: {
		profileClickHandler(event) {
			if (!this.isAuthenticated) {
				event.preventDefault();
				this.$modal.show(MODAL_TYPES.LOGIN);
			}
		},
		mymapsClickHandler(event) {
			if (!this.isAuthenticated) {
				event.preventDefault();
				this.$modal.show(MODAL_TYPES.LOGIN, {propsData: {next: this.url.profile}});
			}
		},
		menuClickHandler(){
			if (this.isProfileMenuOpened) {
				this.isProfileMenuOpened = false
			}
		},
		profileMenuClickHandler(event){
			this.profileClickHandler(event)
			if (this.isMenuOpened){
				this.isMenuOpened = false
			}
		},
	},

	mounted() {
    const headerEl = document.querySelector(".header")

    window.document.onscroll = () => {
      headerEl.classList.toggle("header--sticky", headerEl.getBoundingClientRect().top < 0);
		};
	},
  components: {
    UnsupportedBrowserMsg
  }
};
</script>
